var setCookieTab: any;
namespace Ir.Components.FormattingRules.Editor {
    export interface IFormattingRuleEditor {
        show();
    }
    interface IViewModel {
        dxPopupOptions: DevExpress.ui.dxPopup.Properties;
        dataGridOptions: DevExpress.ui.dxDataGrid.Properties;
        dataGridComponent: DevExpress.ui.dxDataGrid;
        scalesDataGridOptions: DevExpress.ui.dxDataGrid.Properties;
        scalesDataGridComponent: DevExpress.ui.dxDataGrid;
    }
    interface IParams {
        callback(component: IFormattingRuleEditor);
    }
    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        let self = this;

        let formattingRules: KnockoutObservableArray<FormattingRule> = ko.observableArray([]);
        let scalesData = ko.observableArray([]);
        let currentFormattingRule: KnockoutObservable<FormattingRule> = ko.observable<FormattingRule>({});
        let allowEditingScale = ko.observable(true);
        let formattingRulesChanged = false;

        formattingRules(FormattingRuleService.allFormattingRules);
        if (irSettings.multiTenant && !loggedUser.permissions.formattingRules()) {
            formattingRules(FormattingRuleService.formattingRules);
        }

        if (formattingRules().length > 0)
            scalesData(formattingRules()[0].scales);
            
        let editorVM = FormattingRuleService.formattingRuleEditor;

        let iconOptions = [
            { value: "none", text: "none" },
            { value: "square-fill", text: "square-fill" },
            { value: "arrow-down", text: "arrow-down" },
            { value: "arrow-down-right", text: "arrow-down-right" },
            { value: "arrow-right", text: "arrow-right" },
            { value: "arrow-up-right", text: "arrow-up-right" },
            { value: "arrow-up", text: "arrow-up" },
            { value: "arrow-down-circle-fill", text: "arrow-down-circle-fill" },
            { value: "arrow-down-right-circle-fill", text: "arrow-down-right-circle-fill" },
            { value: "arrow-right-circle-fill", text: "arrow-right-circle-fill" },
            { value: "arrow-up-right-circle-fill", text: "arrow-up-right-circle-fill" },
            { value: "arrow-up-circle-fill", text: "arrow-up-circle-fill" },
            { value: "arrow-down-square-fill", text: "arrow-down-square-fill" },
            { value: "arrow-down-right-square-fill", text: "arrow-down-right-square-fill" },
            { value: "arrow-right-square-fill", text: "arrow-right-square-fill" },
            { value: "arrow-up-right-square-fill", text: "arrow-up-right-square-fill" },
            { value: "arrow-up-square-fill", text: "arrow-up-square-fill" },
            { value: "caret-down-fill", text: "caret-down-fill" },
            { value: "caret-right-fill", text: "caret-right-fill" },
            { value: "caret-up-fill", text: "caret-up-fill" },
            { value: "circle", text: "circle" },
            { value: "circle-half", text: "circle-half" },
            { value: "circle-fill", text: "circle-fill" },
        ];

        let popupComponent: DevExpress.ui.dxPopover;

        self.dxPopupOptions = {
            width: 620,
            height: 590,
            showTitle: true,
            title: "Formatting Rules",
            visible: false,
            dragEnabled: false,
            hideOnOutsideClick: false,
            showCloseButton: true,
            position: {
                at: "center",
                my: "center",
            },
            container: undefined,
            onHiding(e) {
                //Find a way to reload only the tab with changed formatting rules
                if (formattingRulesChanged) {
                    workbook.workbookConfig.forceTabsRefresh();
                    workbook.workbookConfig.activeTab().refresh();
                    formattingRulesChanged = false;
                }
            },
            onInitialized(e) {
                popupComponent = e.component as any;
                if (params.callback) {
                    params.callback({
                        show() {
                            popupComponent.show();
                        },
                    } as IFormattingRuleEditor);
                }
            },
            onShown(e) {
                if (self.dataGridComponent) {
                    self.dataGridComponent.updateDimensions();
                }

                if (self.scalesDataGridComponent) {
                    self.scalesDataGridComponent.updateDimensions();
                }
            }
        };

        self.dataGridOptions = {
            height: 300,
            dataSource: formattingRules,
            columns: [/*"id",*/
                {
                    dataField: "name",
                    caption: "Name",
                    sortOrder: "asc",
                    calculateCellValue: function (rowData) {
                        return ko.unwrap(rowData.name);
                    },
                    //setCellValue: function (newData, value, rowData) {
                    //    rowData.name(value);
                    //},
                    validationRules: [{
                        message: "Name is not unique",
                        type: 'custom',
                        validationCallback: function (e) {
                            let valid = formattingRules().filter(function (x) { return x.name == e.value && x.id !== e.data.id; }).length == 0;
                            return valid;
                        }
                    }, {
                        type: "custom",
                        validationCallback: function (v) {
                            if (v.value === undefined || v.value === null) {
                                return false;
                            }

                            if (v.value.trim() === "") {
                                return false;
                            }

                            return true;
                        },
                        message: "Name is required"
                    }]
                },
                {
                    dataField: "organisationId",
                    caption: "Organisation",
                    visible: irSettings.multiTenant,
                    setCellValue(rowData, value) {
                        (this as any).defaultSetCellValue(rowData, value);
                        rowData.companyId = 0;
                    },
                    lookup: {
                        dataSource: editorVM.organizations || [],
                        displayExpr: 'name',
                        valueExpr: 'id',
                    }
                },
                {
                    dataField: "companyId",
                    caption: "Company",
                    visible: irSettings.multiTenant,
                    lookup: {
                        dataSource(options) {
                            return {
                                store: editorVM.companies || [],
                                filter: options.data ? [['organisationId', '=', options.data.organisationId], 'or', [['organisationId', '=', 0], 'and', ['id', '<>', 0]]] : null,
                            };
                        },
                        displayExpr: 'name',
                        valueExpr: 'id',
                    }
                },
                {
                    dataField: "config.applyRow",
                    caption: "Apply on Row",
                    width: 100,
                    dataType: "boolean"
                },
                {
                    dataField: "externalId",
                    visible: false,
                },
                {
                    type: "buttons",
                    buttons: [{
                        name: "edit",
                        visible: function (e) {
                            let formattingRule: FormattingRule = e.row.data;
                            if (irSettings.multiTenant && (!formattingRule.organisationId || formattingRule.organisationId === 0) && !loggedUser.permissions.formattingRules()) {
                                return false;
                            }
                            return true;
                        }
                    }, {
                        name: "delete",
                        visible: function (e) {
                            let formattingRule: FormattingRule = e.row.data;
                            if (irSettings.multiTenant && (!formattingRule.organisationId || formattingRule.organisationId === 0) && !loggedUser.permissions.formattingRules()) {
                                return false;
                            }
                            return true;
                        }
                    }, {
                        hint: "Clone",
                        icon: "copy",
                        visible: function (e) {
                            return !e.row.isEditing;
                        },
                        onClick: function (e) {
                            let clonedItem = new FormattingRule(e.row.data);
                            clonedItem.name = clonedItem.name + "- Copy";
                            clonedItem.externalId = 0;
                            clonedItem.id = 0;

                            let newName = clonedItem.name;
                            let countName = 1;
                            while (formattingRules().filter(function (x) { return x.name == newName; }).length > 0) {
                                newName = `${clonedItem.name} ${countName}`;
                                countName++;
                            }
                            clonedItem.name = newName;

                            if (irSettings.multiTenant && (!clonedItem.organisationId || clonedItem.organisationId === 0) && !loggedUser.permissions.formattingRules()) {
                                clonedItem.organisationId = editorVM.organizationId;
                            }

                            formattingRules.push(clonedItem);
                            clonedItem.save(true, function () {
                                e.component.option("focusedRowKey", clonedItem.id);
                            });
                            formattingRulesChanged = true;
                        }
                    }, {
                        hint: "Formatting Rule Info",
                        icon: "contentlayout",
                        onClick: function (e) {
                            let formattingRule: FormattingRule = e.row.data;
                            Ir.Components.General.ForeignKeyInfo.show({
                                title: `Formatting Rule Info: ${formattingRule.name}`,
                                url: `${urlConfigs.formattingRules}FormattingRuleInfo/${formattingRule.id}`,
                                createTabs(result) {
                                    return [
                                        {
                                            name: "Reports",
                                            dataSource: result.items,
                                            columns: [
                                                { dataField: "workbookId", caption: "Id", dataType: "string" },
                                                { dataField: "workbookName", caption: "Name" },
                                                { dataField: "tabName" },
                                                { dataField: "source" },
                                                { dataField: "owner" },
                                                {
                                                    type: 'buttons',
                                                    width: 50,
                                                    buttons: [{
                                                        hint: 'Open workbook',
                                                        icon: 'link',
                                                        onClick(e) {
                                                            let o = {
                                                                url: `${urlConfigs.tabs}CanAccessWorkbook`,
                                                                data: {
                                                                    userId: loggedUser.id(),
                                                                    workbookId: e.row.data.workbookId,
                                                                    companyId: loggedUser.companyId()
                                                                },
                                                                dataType: "json",
                                                                async: false,
                                                            } as RequestServerParams;
                                                            o.successFunction = function (data) {
                                                                if (data.success) {
                                                                    if (e.row.data.tabId > 0) {
                                                                        window.open(`${window.location.origin}/wb/edit/${e.row.data.workbookId}?tabId=${e.row.data.tabId}`, '_blank').focus();
                                                                    }
                                                                    else {
                                                                        window.open(`${window.location.origin}/wb/edit/${e.row.data.workbookId}`, '_blank').focus();
                                                                    }
                                                                }
                                                                else {
                                                                    DevExpress.ui.notify(data.message);
                                                                }
                                                            };
                                                            o.failureFunction = function () {
                                                                DevExpress.ui.notify("Workbook not found or no access permission");
                                                            };

                                                            irGlobal.requestServer(o);
                                                        }
                                                    }]
                                                }
                                            ]
                                        },
                                        {
                                            name: "Reports Template",
                                            dataSource: result.reportsTemplate,
                                            columns: [
                                                { dataField: "reportId", caption: "Id", dataType: "string" },
                                                { dataField: "reportName", caption: "Name" },
                                                {
                                                    type: 'buttons',
                                                    width: 50,
                                                    buttons: [{
                                                        hint: 'Show report template',
                                                        visible: loggedUser.permissions.mappings(),
                                                        icon: 'link',
                                                        onClick(e) {
                                                            if (setCookieTab) {
                                                                setCookieTab(e.row.data.mappingId, "#reports");
                                                            }

                                                            window.open(`${window.location.origin}/Mapping/Detail/${e.row.data.mappingId}`, '_blank').focus();
                                                        }
                                                    }],
                                                }
                                            ]
                                        },
                                        {
                                            name: "Metrics",
                                            dataSource: result.metrics,
                                            columns: [
                                                { dataField: "metricId", caption: "Id", dataType: "string" },
                                                { dataField: "metricName", caption: "Name" },
                                                {
                                                    type: 'buttons',
                                                    width: 50,
                                                    buttons: [{
                                                        hint: 'Open metric',
                                                        icon: 'link',
                                                        onClick(e) {
                                                            window.open(`${window.location.origin}/Mapping/UpdateMetric/${e.row.data.mappingId}?metricID=${e.row.data.metricId}`, '_blank').focus();
                                                        }
                                                    }],
                                                    visible: loggedUser.permissions.mappings()
                                                }
                                            ]
                                        },
                                    ];
                                }
                            } as Ir.Components.General.ForeignKeyInfo.IForeignKeyInfoParams);
                        }
                    }]
                }
            ],
            showBorders: true,
            editing: {
                mode: "row",
                allowUpdating: true,
                allowDeleting: true,
                allowAdding: true,
                useIcons: true,
            },
            scrolling: {
                useNative: false
            },
            paging: {
                enabled: false,
            },
            focusedRowEnabled: true,
            keyExpr: "id",
            focusedRowIndex: 0,
            onInitialized(e) {
                self.dataGridComponent = e.component;
            },
            onFocusedRowChanged(e) {
                let formattingRule: FormattingRule = e.row.data;
                currentFormattingRule(formattingRule);
                scalesData(formattingRule.scales);

                if (irSettings.multiTenant) {
                    if ((!formattingRule.organisationId || formattingRule.organisationId === 0) && !loggedUser.permissions.formattingRules()) {
                        allowEditingScale(false);
                    }
                    else {
                        allowEditingScale(true);
                    }
                }
                else {
                    allowEditingScale(true);
                }
            },
            onInitNewRow(e) {
                let newFormattingRule = new FormattingRule(null);
                let newName = newFormattingRule.name;
                let countName = 1;
                while (formattingRules().filter(function (x) { return x.name == newName; }).length > 0) {
                    newName = `${newFormattingRule.name} ${countName}`;
                    countName++;
                }

                if (irSettings.multiTenant && !loggedUser.permissions.formattingRules()) {
                    newFormattingRule.organisationId = editorVM.organizationId;
                }

                newFormattingRule.name = newName;
                e.data = newFormattingRule;
            },
            onRowInserted(e) {
                let formattingRule: FormattingRule = e.data;
                formattingRule.save(true, function () {
                    e.component.option("focusedRowKey", formattingRule.id);
                    currentFormattingRule(formattingRule);
                });
                formattingRulesChanged = true;
            },
            onRowUpdated(e) {
                let formattingRule: FormattingRule = e.data;
                formattingRule.save();
                formattingRulesChanged = true;
            },
            onRowRemoving(e) {
                let rule: FormattingRule = e.data;
                rule.delete(function () {
                    formattingRulesChanged = true;
                }, function (failureText) {
                    e.cancel = true;
                    DevExpress.ui.notify(failureText);
                });                
            },
            onRowRemoved(e) {
                formattingRules.remove(e.data);
                scalesData([]);
                formattingRulesChanged = true;
            },
            onEditorPrepared(options) {
                if (irSettings.multiTenant && options.dataField == 'organisationId') {
                    if (!loggedUser.permissions.formattingRules()) {
                        options.editorElement.dxSelectBox('instance').option("disabled", true);
                    }
                    else {
                        options.editorElement.dxSelectBox('instance').option("disabled", false);
                    }
                }
            }
        };

        self.scalesDataGridOptions = {
            height: 230,
            dataSource: scalesData,
            columns: [
                {
                    dataField: "name",
                    caption: "Name",
                    allowSorting: false,
                },
                {
                    dataField: "fontColor",
                    caption: "Font Color",
                    allowSorting: false,
                    spectrum: true,
                    cellTemplate: colorCellTemplate,
                } as DevExpress.ui.dxDataGrid.Column<any, any> & { spectrum: boolean },
                {
                    dataField: "backgroundColor",
                    caption: "Background",
                    allowSorting: false,
                    spectrum: true,
                    //editCellTemplate: colorPickerTemplate,
                    cellTemplate: colorCellTemplate,
                },
                {
                    dataField: "icon",
                    caption: "Icon",
                    allowSorting: false,
                    validationRules: [{ type: "required" }],
                    editCellTemplate: function (cellElement, cellInfo) {
                        let div = $("<div>") as any;
                        return div.dxLookup({
                            dataSource: iconOptions,
                            displayExpr: "text",
                            valueExpr: "value",
                            value: cellInfo.value,
                            searchEnabled: false,
                            dropDownOptions: {
                                height: 200,
                                hideOnOutsideClick: true,
                                showCloseButton: false,
                                showTitle: false
                            },
                            itemTemplate: function (data) {
                                if (data.value === "none") {
                                    return `<div class="formattingRules-noicon-edit"><span>No icon</span></div>`
                                }

                                return `<div style="color:${getColor(cellInfo.data.color)};" class="formattingRules-icon-edit"><i class="bi-${data.value}"></i></div>`;
                            },
                            fieldTemplate: function (data) {
                                if (data.value === "none") {
                                    return `<div class="formattingRules-noicon-edit"><span>No icon</span></div>`
                                }

                                return `<div style="color:${getColor(cellInfo.data.color)};" class="formattingRules-icon-edit"><i class="bi-${data.value}"></i></div>`;
                            },
                            onValueChanged: function (e) {
                                if (e.previousValue !== e.value)
                                    cellInfo.setValue(e.value);
                            }
                        } as DevExpress.ui.dxLookup.Properties);
                    },
                    cellTemplate: function (container, options) {
                        let div = $(`<div style="color:${getColor(options.data.color)};" class="formattingRules-icon-edit"><i class="bi-${options.value}"></i></div>`);
                        div.appendTo(container);
                    }
                },
                {
                    dataField: "color",
                    caption: "Icon Color",
                    allowSorting: false,
                    //validationRules: [{ type: "required" }],
                    spectrum: true,
                    //editCellTemplate: colorEditorTemplate,
                    cellTemplate: colorCellTemplate,
                    setCellValue: function (rowData, value, currentRowData) {
                        rowData.color = value;
                        rowData.icon = rowData.icon || currentRowData.icon;
                    },
                },
                {
                    dataField: "minValue",
                    caption: "Min. Value",
                    allowSorting: false,
                    sortOrder: "asc",
                    validationRules: [{ type: "required" }],
                }
            ],
            showBorders: true,
            editing: {
                mode: "row",
                allowUpdating: allowEditingScale,
                allowDeleting: allowEditingScale,
                allowAdding: allowEditingScale as any,
                useIcons: true,
            },
            focusedRowEnabled: true,
            keyExpr: "id",
            scrolling: {
                useNative: false
            },
            onInitialized(e) {
                self.scalesDataGridComponent = e.component;
            },
            onInitNewRow(e) {
                e.data = new FormattingRuleScale(currentFormattingRule(), null);
            },
            onRowInserting(e) {
                if (currentFormattingRule() && currentFormattingRule().id <= 0) {
                    e.cancel = true;
                    DevExpress.ui.dialog.alert("Save the formatting rule first", "Formatting Rules");
                }
            },
            onRowRemoving(e) {
                if (currentFormattingRule() && currentFormattingRule().id <= 0) {
                    e.cancel = true;
                    DevExpress.ui.dialog.alert("Save the formatting rule first", "Formatting Rules");
                }
            },
            onRowUpdating(e) {
                if (currentFormattingRule() && currentFormattingRule().id <= 0) {
                    e.cancel = true;
                    DevExpress.ui.dialog.alert("Save the formatting rule first", "Formatting Rules");
                }
            },
            onRowInserted(e) {
                currentFormattingRule().save();
                e.component.option("focusedRowKey", e.data.id);
                formattingRulesChanged = true;
            },
            onRowUpdated(e) {
                currentFormattingRule().save();
                formattingRulesChanged = true;
            },
            onRowRemoved(e) {
                currentFormattingRule().save();
                formattingRulesChanged = true;
            },
            onEditorPreparing(e: DevExpress.ui.dxDataGrid.EditorPreparingEvent & { spectrum: boolean }) {
                if (e.parentType === 'dataRow' && e.spectrum) {
                    let input = $(`<input type="text" />`) as any;
                    input.appendTo(e.editorElement);
                    input.spectrum({
                        type: "color",
                        color: e.value,
                        hideAfterPaletteSelect: "true",
                        showInitial: true,
                        showAlpha: false,
                        allowEmpty: true,
                        showInput: true,
                        appendTo: "body",
                        change: function (color) {
                            if (color)
                                e.setValue(color.toHexString());
                            else
                                e.setValue("");
                        }
                    });
                    e.editorElement.css("text-align", "center");
                    $(".sp-replacer.sp-light", e.editorElement).css("width", "40px").css("height", "25px");
                    $(".sp-dd", e.editorElement).css("line-height", "25px");

                    e.cancel = true;
                }
            }
        };
    }

    function colorCellTemplate(container, options) {
        let div = $(`<div style="height: 20px; width: 20px; background-color: ${options.value}; margin: auto;"></div>`);
        div.appendTo(container);
    }

    function getColor(color: string, defaultColor: string = "unset") {
        if (!color || color.toLowerCase() === "transparent") {
            return defaultColor;
        }
        return color;
    }
}